import { getConstant } from '../utils';

export const getCarouselData = getConstant('GET_CAROUSEL_DATA');
export const getCarouselCultures = getConstant('GET_CAROUSEL_CULTURES');
export const getCarouselSymptoms = getConstant('GET_CAROUSEL_SYMPTOMS');